import _classCallCheck from "/vercel/path0/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
/* eslint-env browser */

/* global module */
export function addDebugMetadata(instance, stackIndex) {
  // @ts-expect-error todo: stacktrace does not exist on error (non standard browser?)
  var _Error = new Error("stacktrace source"),
    stack = _Error.stack,
    stacktrace = _Error.stacktrace,
    message = _Error.message;
  instance.debug = {
    stackInfo: {
      stack: stack,
      stacktrace: stacktrace,
      message: message
    },
    stackIndex: stackIndex
  };
} // DEVTOOLS SETUP

export var setupDevtoolsExtension = function setupDevtoolsExtension() {
  var atomicMap = {};
  var extensionsMap = new Map();
  var stylesMap = new Map();
  var getStyles = function getStyles(className) {
    var styles = {};
    if (typeof className !== "string") {
      return styles;
    }
    if (stylesMap.has(className)) {
      styles.styles = stylesMap.get(className);
      var classList = className.split(" ");
      if (classList.length) {
        var classes = {};
        classList.forEach(function (singleClassName) {
          classes[singleClassName] = atomicMap[singleClassName];
        });
        styles.classes = classes;
      }
      if (extensionsMap.has(className)) {
        var extension = extensionsMap.get(className);
        styles.extends = extension;
      }
      return styles;
    }
  };
  window.__STYLETRON_DEVTOOLS__ = {
    atomicMap: atomicMap,
    extensionsMap: extensionsMap,
    stylesMap: stylesMap,
    getStyles: getStyles
  };
}; // todo: export debug engine interface

export var BrowserDebugEngine = /*#__PURE__*/function () {
  function BrowserDebugEngine(worker) {
    _classCallCheck(this, BrowserDebugEngine);
    if (!worker) {
      var workerBlob = new Blob(["importScripts(\"https://unpkg.com/css-to-js-sourcemap-worker@2.0.5/worker.js\")"], {
        type: "application/javascript"
      });
      worker = new Worker(URL.createObjectURL(workerBlob));
      worker.postMessage({
        id: "init_wasm",
        url: "https://unpkg.com/css-to-js-sourcemap-worker@2.0.5/mappings.wasm"
      });
      worker.postMessage({
        id: "set_render_interval",
        interval: 120
      });
      if (module.hot) {
        module.hot.addStatusHandler(function (status) {
          if (status === "dispose") {
            worker.postMessage({
              id: "invalidate"
            });
          }
        });
      }
    }
    this.worker = worker;
    this.counter = 0;
    this.worker.onmessage = function (msg) {
      var _msg$data = msg.data,
        id = _msg$data.id,
        css = _msg$data.css;
      if (id === "render_css" && css) {
        var style = document.createElement("style");
        style.appendChild(document.createTextNode(css));
        document.head.appendChild(style);
      }
    };
  }
  _createClass(BrowserDebugEngine, [{
    key: "debug",
    value: function debug(_ref) {
      var stackIndex = _ref.stackIndex,
        stackInfo = _ref.stackInfo;
      var className = "__debug-".concat(this.counter++);
      this.worker.postMessage({
        id: "add_mapped_class",
        className: className,
        stackInfo: stackInfo,
        stackIndex: stackIndex
      });
      return className;
    }
  }]);
  return BrowserDebugEngine;
}(); // todo: export debug engine interface

export var NoopDebugEngine = /*#__PURE__*/function () {
  function NoopDebugEngine() {
    _classCallCheck(this, NoopDebugEngine);
  }
  _createClass(NoopDebugEngine, [{
    key: "debug",
    value: function debug() {
      return;
    }
  }]);
  return NoopDebugEngine;
}();
export var DebugEngine = true ? BrowserDebugEngine : NoopDebugEngine;